import React, { Component } from 'react';
import Bill_Header from './Bill_Header';
import Table_Header from './Table_Header';
import Table_Body from './Table_Body';
import Table_Footer from './Table_Footer';

export default class Power_Consumption extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		if (this.props.tenant_info[this.props.tenant_name].points.length <= 18) {
			// Fit in 1 page
			return (
				<div style={{ pageBreakAfter: 'always', breakAfter: 'always' }}>
					{/* Power Consumption table */}
					<div id="power_consumption" className="power-consumption-page">
						<Bill_Header
							receiver={this.props.receiver}
							tenant_name={this.props.tenant_name}
							from_date={this.props.from_date}
							to_date={this.props.to_date}
						/>
						{/* Power Consumption title */}
						<div style={{ display: 'inline-block', margin: 30 }}>
							<span className="power_title">{this.props.receiver.getString("power_consumption_header")}</span>
							<span className="power_subtitle"> [kWh]</span>
						</div>

						{/* Table */}
						<table className='power-consumption-table'>
							<Table_Header
								receiver={this.props.receiver}
								price_info={this.props.price_info}
							/>
							<Table_Body
								receiver={this.props.receiver}
								points={this.props.tenant_info[this.props.tenant_name].points}
								price_info={this.props.price_info}
								bill_data={this.props.bill_data}
							/>
							<Table_Footer
								receiver={this.props.receiver}
								tenant_name={this.props.tenant_name}
								price_info={this.props.price_info}
								bill_data={this.props.bill_data}
							/>
						</table>

						{/* Owner Information */}
						<div style={{ marginTop: 20, textAlign: 'end', paddingRight: 30 }}>
							<span class="owner_name">{this.props.owner_info.name}</span>
							<span class="owner_info">{this.props.owner_info.addr1}</span>
							<span class="owner_info">{this.props.owner_info.addr2}</span>
							<span class="owner_info">{this.props.owner_info.postalcode}</span>
							<span class="owner_info">{this.props.owner_info.contact}</span>
							<span class="owner_info">{this.props.owner_info.tel}</span>
							<span class="owner_info">{this.props.owner_info.email}</span>
						</div>

					</div>

					<div style={{ height: 20 }}></div>
				</div>
			)
		} else {
			let paged_points = [];
			let points = [...this.props.tenant_info[this.props.tenant_name].points];
			paged_points.push(points.splice(0, 18));

			while (points.length > 0) {
				let full_page_max_points = 22;
				if (points.length > full_page_max_points) {
					paged_points.push(points.splice(0, full_page_max_points));
				} else {
					paged_points.push(points.splice(0, points.length))
				}
			}

			return (
				<div>
					{paged_points.map((points, index) => {
						let last_index = paged_points.length - 1;
						let is_first_page = index == 0;
						let is_last_page = index == last_index;

						return (
							<div style={{ pageBreakAfter: 'always', breakAfter: 'always' }}>
								{/* Power Consumption table */}
								<div id="power_consumption" className="power-consumption-page">
									{is_first_page ?
										<div>
											<Bill_Header
												receiver={this.props.receiver}
												tenant_name={this.props.tenant_name}
												from_date={this.props.from_date}
												to_date={this.props.to_date}
											/>
											{/* Power Consumption title */}
											<div style={{ display: 'inline-block', margin: 30 }}>
												<span className="power_title">{this.props.receiver.getString("power_consumption_header")}</span>
												<span className="power_subtitle"> [kWh]</span>
											</div>
										</div>
										: null}

									{/* Table */}
									<table className='power-consumption-table'>
										<Table_Header
											receiver={this.props.receiver}
											price_info={this.props.price_info}
										/>
										<Table_Body
											receiver={this.props.receiver}
											points={points}
											price_info={this.props.price_info}
											bill_data={this.props.bill_data}
										/>
										{is_last_page ?
											<Table_Footer
												receiver={this.props.receiver}
												tenant_name={this.props.tenant_name}
												price_info={this.props.price_info}
												bill_data={this.props.bill_data}
											/>
											: null}
									</table>

									{is_last_page ?
										<div style={{ marginTop: 20, textAlign: 'end', paddingRight: 30 }}>
											<span class="owner_name">{this.props.owner_info.name}</span>
											<span class="owner_info">{this.props.owner_info.addr1}</span>
											<span class="owner_info">{this.props.owner_info.addr2}</span>
											<span class="owner_info">{this.props.owner_info.postalcode}</span>
											<span class="owner_info">{this.props.owner_info.contact}</span>
											<span class="owner_info">{this.props.owner_info.tel}</span>
											<span class="owner_info">{this.props.owner_info.email}</span>
										</div>
										: null}
								</div>

								<div style={{ height: 20 }}></div>
							</div>

						)
					})}
				</div>
			)


		}
	}
}